import { SNAPSHOT_PAGE_CONFIG } from './config.js';
import { bootstrapSortableTablePage } from '../shared/page-entry.js';

bootstrapSortableTablePage(SNAPSHOT_PAGE_CONFIG);
